<template>
  <div class="layout">
    <Header></Header>
    <div class="main">
      <router-view />
    </div>
    <div class="layout-footer">
      <Footer></Footer>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";

export default {
  components: {
    Header,
    Footer,
  },
  data() {
    return {};
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.layout {
  width: 100%;
  min-height: 100%;
  display: flex;
  flex-direction: column;
}
.main {
  flex: 1;
  padding-top: 80px; /* 为固定头部留出空间 */
}
// .page {
//   /* 让当前路由页面获得明确的父级高度，便于子级 height:100% 生效 */
//   min-height: calc(100vh - 80px - 420px);
//   width: 100%;
// }
.layout-footer {
  margin-top: auto;
  // height: 420px;
  width: 100%;
  background: #212121;
}
</style>
